import { BlockNoteEditor, Block } from '@blocknote/core';

/**
 * Extracts text content from block.content array
 * @param content - The content array from a block
 * @returns The concatenated text content
 */
const extractTextFromContent = (content: any[]): string => {
  return content
    .map((contentBlock) =>
      contentBlock.type === 'text' && 'text' in contentBlock ? contentBlock.text : ''
    )
    .join('');
};

/**
 * Updates a block by moving content to a custom property and clearing the content array
 * @param editor - The BlockNote editor instance
 * @param block - The block to update
 * @param propertyName - The name of the custom property to store the content
 * @param value - The new value to set
 */
export const updateBlockWithContentMigration = (
  editor: BlockNoteEditor<any, any, any>,
  block: Block<any, any, any>,
  propertyName: string,
  value: string
): void => {
  editor.updateBlock(block, {
    props: {
      ...block.props,
      [propertyName]: value,
    },
    content: [], // Clear the content array
  });
};

/**
 * Gets the value from either block.content (extracted as text) or a custom property
 * @param block - The block to get the value from
 * @param propertyName - The name of the custom property to check
 * @returns The value from content or the custom property
 */
export const getBlockValue = (block: any, propertyName: string): string => {
  const contentValue = extractTextFromContent(block.content);
  return contentValue || block.props[propertyName] || '';
};
